import BusinessApi from "./BusinessApi";

export const fetchFeatures = () => {
    return BusinessApi.get(`/api/features`);
};